export const SAVANNA_DEVICE_NAME = 'Savanna';
export const SOFIA2_DEVICE_NAME = 'Sofia2';

export enum INPUT_TYPES {
  SAMPLES = 1,
  CONDITIONS = 2,
}
